<template>
  <div>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <v-menu
          v-model="startDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="formattedStartDate"
              label="Начало периода"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="startDate"
            @input="startDateMenu = false"
            :max="endDate"
          ></v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-menu
          v-model="endDateMenu"
          :close-on-content-click="false"
          :nudge-right="40"
          transition="scale-transition"
          offset-y
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="formattedEndDate"
              label="Окончание периода"
              prepend-icon="mdi-calendar"
              readonly
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="endDate"
            @input="endDateMenu = false"
            :max="$moment().format('YYYY-MM-DD')"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
    <v-data-table :headers="headers" :items="items" item-key="user_name" class="elevation-1" expand>
      <template v-slot:item.user_name="{ item }">
        <div @click="onItemClick(item)" style="cursor: pointer">{{ item.user_name }}</div>
      </template>
    </v-data-table>
    <LineChart v-if="dataLoaded" :chart-data="chartdata" />
  </div>
</template>

<script>
import { getPositionEventsTable } from '@/api/referenece'
import { PositionKind, Role } from '@/api/consts'
import LineChart from '@/components/charts/LineChart'
import { getDateRange } from '@/utils/dates'
import { getRandomRGB } from '@/utils/colors'

export default {
  name: 'PositionEvents',
  components: { LineChart },
  data() {
    return {
      dataLoaded: false,
      chartDialog: false,
      startDateMenu: false,
      startDate: this.$moment().add(-17, 'days').format('YYYY-MM-DD'),
      endDate: this.$moment().format('YYYY-MM-DD'),
      currentChartUser: {
        user_name: '',
        range: {},
      },
      endDateMenu: false,
      chartdata: null,
      items: [],
      headers: [
        {
          text: 'Имя',
          align: 'start',
          sortable: true,
          value: 'user_name',
        },
        {
          text: 'Дата последней авторизации',
          align: 'start',
          sortable: true,
          value: 'last_login',
        },
        {
          text: 'Количество мероприятий',
          align: 'start',
          sortable: true,
          value: 'total_events',
        },
        {
          text: 'В среднем в день',
          align: 'start',
          sortable: true,
          value: 'avg_events',
        },
        {
          text: 'Должность',
          align: 'start',
          sortable: true,
          value: 'position_kind_string',
        },
        {
          text: 'Регион',
          align: 'start',
          sortable: true,
          value: 'region.title',
        },
      ],
    }
  },
  computed: {
    formattedStartDate() {
      const date = this.$moment(this.startDate)
      return date.isValid() ? date.format('LL') : ''
    },
    formattedEndDate() {
      const date = this.$moment(this.endDate)
      return date.isValid() ? date.format('LL') : ''
    },
    currentDateRange() {
      return getDateRange(this.$moment(this.startDate), this.$moment(this.endDate))
    },
    chartLabels() {
      return this.currentDateRange.map((x) => {
        return x.format('LL')
      })
    },
  },
  watch: {
    async startDate() {
      await this.updateDataTable()
    },
    async endDate() {
      await this.updateDataTable()
    },
  },
  async mounted() {
    await this.getTableData()
    this.chartdata = {
      labels: this.chartLabels,
      datasets: this.getAllItemsData(),
    }
    this.dataLoaded = true
  },
  methods: {
    async updateDataTable() {
      await this.getTableData()
      this.chartdata = {
        labels: this.chartLabels,
        datasets: this.getAllItemsData(),
      }
      this.dataLoaded = true
    },
    getItemChartData(item, color) {
      return {
        label: item.user_name,
        backgroundColor: color || getRandomRGB(),
        data: this.currentDateRange.map((x) => {
          const range = item.events_info || {}
          const val = range[x.format('YYYY-MM-DD')]
          return val ? val : 0
        }),
      }
    },
    getAllItemsData() {
      return this.items
        .filter((x) => {
          return x.total_events > 0
        })
        .map((x) => {
          return this.getItemChartData(x)
        })
    },
    async getTableData() {
      const resp = await getPositionEventsTable(
        this.axios,
        [PositionKind.DeputyCandidate],
        this.startDate,
        this.endDate
      )
      this.items = resp.data.map((x) => {
        const t = this.$moment(x.last_login)
        x.last_login = t.isValid() ? t.format('LLL') : null
        x.avg_events = Math.floor(x.total_events / this.currentDateRange.length)
        return x
      })
    },
    onItemClick(item) {
      // this.chartDialog = true
      this.$log.debug('click on item', item)
      this.currentChartUser = { ...item }
      const chartdata = {
        labels: this.chartLabels,
        datasets: [this.getItemChartData(this.currentChartUser, 'rgba(27,163,87,0.76)')],
      }
      this.dataLoaded = true
      this.$set(this, 'chartdata', chartdata)
    },
  },
}
</script>
